<template>
  <div>
    <div class="check_main">
      <h3 class="check_main__title">Check Tools</h3>

      <div>
        <b-card
          title="Sleep Image Checktools"
          class="check_main__item"
          sub-title="Sleep scense related check tools"
        >
          <b-button
            variant="primary"
            class="btn btn-info item__label--btn"
            @click.prevent="goSleepCheck('feedback')"
          >UserFeedback</b-button>
          <b-button
            variant="primary"
            class="btn btn-info item__label--btn"
            @click.prevent="goSleepCheck('alert')"
          >Alerts</b-button>
          <b-button
            variant="primary"
            class="btn btn-info item__label--btn"
            @click.prevent="goSleepCheck('album')"
          >Albums</b-button>
          <b-button
            variant="primary"
            class="btn btn-warning item__label--btn"
            @click.prevent="goSleepCheck('records')"
          >Records</b-button>
        </b-card>
        <b-card
          title="Live Image Checktools"
          class="check_main__item"
          sub-title="Live scense related check tools"
        >
          <b-button variant="primary" class="btn btn-info item__label--btn">UserFeedback</b-button>
          <b-button variant="primary" class="btn btn-info item__label--btn">Alerts</b-button>
          <b-button variant="primary" class="btn btn-info item__label--btn">Albums</b-button>
          <b-button variant="primary" class="btn btn-warning item__label--btn">Records</b-button>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goSleepCheck(type) {
      // /meta/${type}/to_label
      this.$router.push(`/check/sleep/${type}`);
    },
  },
};
</script>
